<script>
  import { onMount } from "svelte";
  import { BASE_URL } from "../../utilities/config.js";
  import { fetchSpeechToken } from "../speechToken.mjs";
  export let textToRead;
  export let language;
  let ttsButtonState = "starting";

  // subscription key and region for speech services.
  let subscriptionKey;
  let serviceRegion = "eastasia";
  let authorizationToken = "";
  let SpeechSDK;
  let synthesizer;
  let player;
  let audioConfig;
  let ttsToken;
  let speechCounter = 0;

  onMount(async () => {
    intialize();
  });

  function intialize() {
    if (!!window.SpeechSDK) {
      SpeechSDK = window.SpeechSDK;
      ttsButtonState = "starting";

      initPlayPage();
    } else {
      ttsButtonState = "error";
      console.error("error with SpeechSDK");
    }
  }

  function initPlayPage() {
    fetchSpeechToken(BASE_URL)
      .then((data) => {
        ttsToken = data.token;
        serviceRegion = data.region;
        ttsButtonState = "ready";
      })
      .catch((error) => {
        console.error("token", error);
        ttsButtonState = "error";
      });
  }

  function playTextToSpeech() {
    if (ttsToken != null) {
      authorizationToken = ttsToken;
    } else {
      console.error("missing token");
      return;
    }
    let voiceName;

    // if we got an authorization token, use the token. Otherwise use the provided subscription key
    let speechConfig;
    if (authorizationToken) {
      speechConfig = SpeechSDK.SpeechConfig.fromAuthorizationToken(
        authorizationToken,
        serviceRegion
      );
    } else {
      if (
        subscriptionKey.value === "" ||
        subscriptionKey.value === "subscription"
      ) {
        alert(
          "Please enter your Microsoft Cognitive Services Speech subscription key!"
        );
        ttsButtonState = "error";
        return;
      }
      speechConfig = SpeechSDK.SpeechConfig.fromSubscription(
        subscriptionKey.value,
        serviceRegion
      );
    }
    if (language == "en-us") {
      language = "en-US";
    } else if (language == "cs-cz") {
      language = "cs-CZ";
    } else if (language == "zh-tw") {
      language = "zh-TW";
    } else if (language == "de-de") {
      language = "de-DE";
    }

    speechConfig.speechSynthesisLanguage = language;
    if (language == "en-US") {
      if (speechCounter % 2 == 1) {
        speechConfig.speechSynthesisVoiceName = "en-US-GuyRUS";
        voiceName = "en-US-GuyRUS";
      } else {
        voiceName = "en-US-JennyNeural";
      }
    } else if (language == "cs-CZ") {
      if (speechCounter % 2 == 1) {
        speechConfig.speechSynthesisVoiceName = "cs-CZ-VlastaNeural";
        voiceName = "cs-CZ-VlastaNeural";
      } else {
        voiceName = "cs-CZ-AntoninNeural";
      }
    } else if (language == "zh-TW") {
      if (speechCounter % 2 == 1) {
        speechConfig.speechSynthesisVoiceName = "zh-TW-HsiaoChenNeural";
        voiceName = "zh-TW-HsiaoChenNeural";
      } else {
        voiceName = "zh-TW-YunJheNeural";
      }
    } else if (language === "de-DE") {
      if (speechCounter % 2 == 1) {
        speechConfig.speechSynthesisVoiceName = "de-DE-KatjaNeural";
        voiceName = "de-DE-KatjaNeural";
      } else {
        voiceName = "de-DE-ConradNeural";
      }
    }
    speechCounter++;

    //speechConfig.speechSynthesisOutputFormat =
    //  SpeechSDK.SpeechSynthesisOutputFormat.Ogg16Khz16BitMonoOpus;

    player = new SpeechSDK.SpeakerAudioDestination();
    audioConfig = SpeechSDK.AudioConfig.fromSpeakerOutput(player);
    synthesizer = new SpeechSDK.SpeechSynthesizer(speechConfig, audioConfig);

    ttsButtonState = "playing";

    let ssml =
      `<speak xmlns="http://www.w3.org/2001/10/synthesis"
       xmlns:mstts="http://www.w3.org/2001/mstts"
       xmlns:emo="http://www.w3.org/2009/10/emotionml"
       version="1.0"
       xml:lang="` +
      language +
      `">
	<voice name="` +
      voiceName +
      `">
		<prosody rate="-20%"
		         pitch="0%">` +
      textToRead +
      `</prosody>
	</voice>
</speak>`;

    synthesizer.speakSsmlAsync(
      ssml,
      function (result) {
        console.log(result);
        if (
          result.reason === SpeechSDK.ResultReason.SynthesizingAudioCompleted
        ) {
          console.log("synthesis finished for [" + textToRead + "]");
        } else if (result.reason === SpeechSDK.ResultReason.Canceled) {
          console.log("synthesis failed. Error detail: " + result.errorDetails);
          ttsButtonState = "error";
        }
        synthesizer.close();
        synthesizer = undefined;
      },
      function (err) {
        ttsButtonState = "error";
        console.log("Synthesizer Error", err);

        synthesizer.close();
        synthesizer = undefined;
      }
    );

    player.onAudioEnd = function (s) {
      console.log("onAudioEnd", s);
      ttsButtonState = "ready";
    };
  }

  export function stopTextToSpeech() {
    console.log(player);
    if (player != null) {
      player.pause();
      ttsButtonState = "ready";
    }
  }

  function clickPlayTTS() {
    console.log("clickPlayTTS", ttsButtonState);
    if (ttsButtonState === "ready") {
      playTextToSpeech();
      ttsButtonState = "playing";
    } else if (ttsButtonState === "playing") {
      stopTextToSpeech();
    }
  }
</script>

{#if ttsButtonState === "starting"}
  TTS initializing...
{:else if ttsButtonState === "playing"}
  <button class="btn btn-success" on:click={clickPlayTTS} type="button">
    <i
      class="fas fa-volume-up spin"
      style="font-size:1.5em; padding: 0.4rem 0rem 0.4rem 0rem;"
    />
  </button>
{:else if ttsButtonState === "ready"}
  <button class="btn btn-primary" on:click={clickPlayTTS} type="button"
    ><i
      class="fas fa-volume-up"
      style="font-size:1.5em; padding: 0.4rem 0rem 0.4rem 0rem;"
    /></button
  >
{:else if ttsButtonState === "error"}TTS Error!{/if}

<style>
  .spin {
    animation-name: stretch;
    animation-duration: 1.5s;
    animation-timing-function: ease-out;
    animation-delay: 0;
    animation-direction: alternate;
    animation-iteration-count: infinite;
    animation-fill-mode: none;
    animation-play-state: running;
  }

  @keyframes stretch {
    50% {
      color: black;
    }
  }
</style>
